import { useEffect } from 'react';
import { useStateMachine } from 'little-state-machine';
import { usePostHog } from 'posthog-js/react';

export default function EventsTriggerWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const { state } = useStateMachine();
  const { insuranceType, providerCode, country } = state;
  const posthog = usePostHog();
  const matchPageLeaveDispatch = insuranceType && providerCode && country;

  const onVisibilityHidden = () => {
    if (document.visibilityState === 'hidden') {
      if (matchPageLeaveDispatch) {
        posthog.capture('quote_page_leave', {
          type: insuranceType,
          country,
          provider_code: providerCode,
        });
      }
    }
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', onVisibilityHidden);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityHidden);
    };
  }, [state]);

  return <>{children}</>;
}
